/**
 * @Author: wuyang
 * @Date: 2024/1/20
 * @Description: ""
 * 常用的公共接口
 */

import { requestInstance } from '@/api/instance'
import { IUserInfo } from '@/types/user'
import { UPLOAD_SERVER_MAX_SIZE } from '@/constant'

/**
 * 上传接口
 * @param file
 */
export const uploadFileApi = (file: File, maxSize = UPLOAD_SERVER_MAX_SIZE) => {
	return requestInstance
		.upload<
			any,
			{
				url: string
			}
		>('/oss/file/fileUploadWithMaxSize', { file, maxSize })
		.fire()
}
// 上传图片
export const uploadFileOssApi = (file: File) => {
	return requestInstance
		.upload<
			any,
			{
				url: string
			}
		>('/oss/file/fileUpload', { file })
		.fire()
}
// 批量上传图片
export const batchUploadOss = (files: any) => {
	return requestInstance
		.upload<
			any,
			{
				url: string
			}
		>('/oss/file/batchUpload', { files })
		.fire()
}
// 批量压缩图片
export const batchZipUrl = (data: any) => {
	return requestInstance.post('/oss/file/batchZipUrl', data).fire()
}
// 通过任务id批量下载压缩图片
export const batchZipUrlById = (data: any) => {
	return requestInstance.get(`/oss/file/batchZipIds/${data.id}`, {}).fire()
}

//上传表格或是csv
export const uploadFileCsvApi = (file: any) => {
	return requestInstance
		.upload<
			any,
			{
				url: string
			}
		>('/oss/file/fileUploadTable', { file })
		.fire()
}

export const downFileApi = (url: string) => {
	return requestInstance.download(url, {}).fire()
}

export const getUserInfo = () => {
	return requestInstance.get<any, IUserInfo>('/front/user/getInfo', {}).fire()
}
/**
 * 初始化上传
 */
export const initiateUpload = (data: any) => {
	return requestInstance
		.upload<any, any>('/local-upload/initiate-batch', data)
		.fire()
}
/**
 * 分批上传文件
 */
export const uploadPart = (data: any) => {
	return requestInstance
		.upload<any, any>('/local-upload/upload-batch', data)
		.fire()
}
/**
 * 上传多个分片
 */
export const uploadMultiplePart = (data: any) => {
	return requestInstance
		.upload<any, any>('/local-upload/complete-batch', data)
		.fire()
}
/**
 *  中止批次上传
 */
export const abortBatchUpload = (data: any) => {
	return requestInstance
		.upload<any, any>('/local-upload/abort-batch', data)
		.fire()
}
/**
 *  上传头像
 */
export const uploadAvatar = (data: any) => {
	return requestInstance
		.upload<any, any>('/system/user/profile/avatar', data)
		.fire()
}
/* 获取是否接受图片上传协议 */
export const getIsAcceptImageUploadAgreement = () => {
	return requestInstance
		.get<any, any>('front/user/disclaimer/status',{})
		.fire()
}
/* 设置是否接受图片上传协议 */
export const setIsAcceptImageUploadAgreement = () => {
	return requestInstance
		.put<any, any>( 'front/user/disclaimer/accept', {} )
		.fire()
}